import type { BasePaginationDto } from '@@types/api.types';
import { AdminPagination } from '@components/ui/admin-pagination';
import React from 'react';

type AdminUsesPaginationProps = {
  isFetching?: boolean;
  onLimitChange: (limit: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  pagination: BasePaginationDto;
};

export const AdminUsesPagination: React.FC<AdminUsesPaginationProps> = (props) => {
  const { isFetching, onLimitChange, onNextPage, onPreviousPage, pagination } = props;

  return (
    <AdminPagination
      isFetching={isFetching}
      itemLabel="uses"
      onLimitChange={onLimitChange}
      onNextPage={onNextPage}
      onPreviousPage={onPreviousPage}
      pagination={pagination}
    />
  );
};
